import React from "react";

import { CircularProgress, Tooltip, Zoom} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

const colors = {
    primary: "rgb(98, 110, 212)",
    secondary: "#6c757d",
    confirm: "#28a745",
    warning: "#ffc107",
    danger: "#dc3545",
    info:'#007bff',
    success: "#28a745",
}

const DefaultButton = ({
    loading = false, 
    disabled = false,
    text = "", 
    loadingtext = "",
    bg = Object.keys(colors)[0], 
    color = "white", 
    variant = "contained", 
    type = "button",
    icon = <></>,
    to,
    routeState = {},
    title = "",
    width = "auto",
    height = "auto",
    padding = "auto",
    style = {},
    onClick = (e) => void 0,
    search='',
    ...other
}) => {

    const history = useHistory();

    return (
        <Tooltip
            title={title}
            TransitionComponent={Zoom}
            {...other}
        >
            <Button
                variant={(bg === 'confirm' ? 'success' : bg)}
                disabled={loading || disabled}
                style={Object.assign({
                    position: "relative",
                    textDecoration: "none",
                    minWidth: "auto",
                    width: width,
                    height: height,
                    padding: padding
                }, style)}
                type={type}
                onClick={(e) => {
                    onClick(e);
                    to && history.push({
                        pathname: to,
                        state: routeState,
                        search: search
                    });
                }}
                className="flex jcc align-center"
            >
                <CircularProgress
                    className={loading ? "" : "hide"}
                    style={{
                        width: "15px",
                        height: "15px",
                        color: color
                    }}
                />
                {icon}
                {loadingtext != "" && loading ? loadingtext : text}
            </Button>
        </Tooltip>
    );
}

export default DefaultButton;
